import React, { useState, useEffect, useRef } from 'react';
import Header from '../../../common/components/Header/Header';
import Sidebar from '../../../common/components/Sidebar/Sidebar';
import Helmet from 'react-helmet';
import { siteTitle } from '../../../../data/SiteConfig';
import EditIcon from '@material-ui/icons/Edit';
import { getBReKycRules, deleteBreRule } from '../../../common/constants/api';
import DeleteIcon from '@material-ui/icons/Delete';
import {
  headerRow,
  bodyRow,
  tableBody,
  tableContainer
} from './BreKyc.module.css';
import PopUp from '../../../common/components/PopUp/PopUp';

import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import BreNewRule from './updateBRERule';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { navigate } from 'gatsby-link';
import InfiniteScroll from '../../../common/components/InfiniteScroll/InfiniteScroll';
import moment from 'moment';
import KYCDrawer from './KYCDrawer';
import AddIcon from '@material-ui/icons/Add';
import Modal from '../../../common/components/Modal/modal';
import { withErrorHandler } from '../../../..';

const headerClasses = `${headerRow} font-open-sans-semi-bold px-2`;
const bodyClasses = `${bodyRow} font-open-sans-semi-bold py-4 px-2 capitalize`;

const BREKYC = () => {
  const [rules, setRules] = useState([]);
  const [pageInfo, setPageInfo] = useState({ number: 1 });
  const [loading, setLoading] = useState(true);
  const [showDrawer, setShowDrawer] = useState(false);
  const [mobileMoreData, setMobileMoreData] = useState({});
  const [addNewRuleMobile, setShowAddNewRule] = useState(false);
  const [toggleFeatue, setToggleFeature] = useState('name');
  const [showDeletePopUp, setShowDeletePopUp] = useState(false);
  const [popUpData, setPopUpData] = useState({
    show: false,
    text: 'loading',
    type: 'loading'
  });

  const [updatgRule, setEditingRule] = useState({});
  const ref = useRef();

  const handleInfiniteScroll = () => {
    getRules({ pageNumber: pageInfo?.number + 1 });
  };

  const deleteBRECondition = () => {
    const ruleId = showDeletePopUp;
    setShowDeletePopUp(false);
    setPopUpData({
      show: true,
      type: 'loading',
      text: (
        <span className="font-open-sans text-base ">
          Deleting the rule! Please wait...
        </span>
      )
    });
    setShowDrawer(false);
    deleteBreRule(ruleId)
      .then(res => {
        setPopUpData({
          show: true,
          type: 'success',
          text: (
            <span className="font-open-sans text-base ">
              The rule has been deleted successfully!
            </span>
          )
        });
        setTimeout(() => {
          setPopUpData(e => {
            return { ...e, show: false };
          });
        }, 3000);
        hanldeAfterNewRule();
      })
      .catch(error => {
        setPopUpData(e => {
          return { ...e, show: false };
        });
      });
  };

  const getRules = ({ pageNumber, reset }) => {
    setLoading(true);
    getBReKycRules({ pageNumber, pageSize: 50 })
      .then(res => {
        if (reset) setRules(res?._embedded?.breKycConditionDtoList || []);
        else
          setRules(e => [
            ...e,
            ...(res?._embedded?.breKycConditionDtoList || [])
          ]);

        setPageInfo(res?.page);
      })
      .catch(error => {})
      .finally(e => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getRules({ pageNumber: 0 });
    return () => {};
  }, []);

  const handleUpdate = (data, disableScroll, ruleName) => {
    setEditingRule(e => {
      return {
        ...e,
        [data?.breKycname]: data
      };
    });
    if (!disableScroll) ref.current.scrollIntoView({ behavior: 'smooth' });
    ruleName && setToggleFeature(ruleName);
  };

  const hanldeAfterNewRule = () => {
    getRules({ pageNumber: 0, reset: true });
  };
  return (
    <div className="w-full bg-navy-600">
      <Helmet title={`Kyc BRE | ${siteTitle}`} />

      <div className="flex w-full">
        <Sidebar />
        <div className="w-full max-h-screen overflow-auto">
          <Header />
          <div className="w-full px-4 pt-20 md:pt-0">
            {!addNewRuleMobile && (
              <div className="md:hidden text-black-1011 text-base font-open-sans-bold flex my-2">
                <div className="w-full" onClick={() => navigate('/app/bre')}>
                  <ArrowBackIcon className="-mt-1" />
                  <span className="ml-1">KYC</span>
                </div>
                <div className="ml-auto float-right">
                  <button
                    className="text-xs white-space-no-wrap font-open-sans-semi-bold border px-2 py-1  rounded mb-5 border-green-1601 text-green-1601"
                    onClick={() => setShowAddNewRule(true)}
                  >
                    <AddIcon className="text-green-1601 text-sm" /> KYC Rules
                  </button>
                </div>
              </div>
            )}
            <div className="hidden md:block table mr-auto text-black-1011 text-sm">
              <span
                onClick={() => navigate('/app/bre')}
                className="text-blue-1301 cursor-pointer"
              >
                BRE
              </span>
              <ChevronRightIcon /> KYC
            </div>
            <div
              className="bg-white hidden md:block px-2  py-4 rounded mb-10 mt-5"
              ref={ref}
            >
              <p className="font-open-sans-bold text-base mb-2">New Rule</p>
              <hr className="" style={{ color: '#E4EEFA' }} />
              <BreNewRule
                rule="name"
                data={updatgRule?.name}
                setEditingRule={setEditingRule}
                onAddingRule={hanldeAfterNewRule}
              />
              <BreNewRule
                rule="dob"
                data={updatgRule?.dob}
                setEditingRule={setEditingRule}
                onAddingRule={hanldeAfterNewRule}
              />
            </div>

            <InfiniteScroll
              bottomLocation={30}
              debounceTime={100}
              handleScrollsuccess={handleInfiniteScroll}
              pageInfo={pageInfo}
              includeFilterLoder={loading}
            >
              <div
                className={`bg-white rounded hidden md:block pb-0.5 pt-6 ${tableContainer}`}
              >
                <table className="w-full ">
                  <thead>
                    <tr className="w-full">
                      <td className={`${headerClasses}`}>Rule</td>
                      <td className={`${headerClasses}`}>Created date</td>
                      <td className={`${headerClasses}`}>Created by</td>
                      <td className={`${headerClasses}`}>Document 1</td>
                      <td className={`${headerClasses}`}>Condition</td>
                      <td className={`${headerClasses}`}>Document 2</td>
                      <td className={`${headerClasses}`}>percentage</td>
                      <td className={`${headerClasses}`}></td>
                    </tr>
                  </thead>
                  <tbody>
                    {rules.map(each => (
                      <tr className={`w-full ${tableBody}`}>
                        <td className={`${bodyClasses} `}>
                          {each?.breKycname}
                        </td>
                        <td className={`${bodyClasses}`}>
                          {moment(each?.createdAt).format('DD MMM YY')}
                        </td>
                        <td className={`${bodyClasses}`}>{`${each?.createdBy
                          ?.firstName || ''} ${each?.createdBy?.middleName ||
                          ''} ${each?.createdBy?.lastName || ''}`}</td>
                        <td className={`${bodyClasses} `}>
                          {`${each?.doc1}`.replace(/_/g, ' ')}
                        </td>
                        <td className={`${bodyClasses}`}>Matches</td>
                        <td className={`${bodyClasses}`}>
                          {`${each?.doc2}`.replace(/_/g, ' ')}
                        </td>
                        <td className={`${bodyClasses}`}>
                          {each?.percentage || '---'}%
                        </td>
                        <td>
                          <span>
                            <EditIcon
                              className="text-base mr-2 cursor-pointer"
                              onClick={() => handleUpdate(each)}
                            />
                            <DeleteIcon
                              className="text-base cursor-pointer"
                              onClick={() => setShowDeletePopUp(`${each?.id}`)}
                            />
                          </span>
                        </td>
                      </tr>
                    ))}
                    {pageInfo?.totalElements === rules?.length && (
                      <tr>
                        <td
                          colSpan="8"
                          className={`${bodyRow} font-open-sans-semi-bold py-4 px-2 text-center`}
                        >
                          No more rules found!
                        </td>
                      </tr>
                    )}
                    {!pageInfo?.totalElements && (
                      <tr>
                        <td
                          colSpan="8"
                          className={`${bodyRow} font-open-sans-semi-bold py-4 px-2 text-center`}
                        >
                          No rules found!
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <div className="grid gap-y-2 md:hidden">
                <KYCDrawer
                  open={showDrawer}
                  setOpen={setShowDrawer}
                  data={mobileMoreData}
                  handleUpdate={handleUpdate}
                  setShowAddNewRule={setShowAddNewRule}
                  onDelete={id => setShowDeletePopUp(`${id}`)}
                />
                {addNewRuleMobile && (
                  <div
                    className="bg-ghostWhite  px-2  py-4 rounded mb-10 "
                    ref={ref}
                  >
                    <p
                      className="font-open-sans-bold text-base mb-2 items-center cursor-pointer"
                      onClick={() => setShowAddNewRule(false)}
                    >
                      <span>
                        <ArrowBackIcon className="-mt-1" />
                      </span>
                      New Rule
                    </p>
                    <BreNewRule
                      rule="name"
                      mobile
                      data={updatgRule?.name}
                      setEditingRule={setEditingRule}
                      onAddingRule={hanldeAfterNewRule}
                      toggleFeatue={toggleFeatue}
                      setToggleFeature={setToggleFeature}
                    />
                    <BreNewRule
                      rule="dob"
                      mobile
                      data={updatgRule?.dob}
                      setEditingRule={setEditingRule}
                      onAddingRule={hanldeAfterNewRule}
                      toggleFeatue={toggleFeatue}
                      setToggleFeature={setToggleFeature}
                    />
                  </div>
                )}
                {!pageInfo?.totalElements && (
                  <p
                    className={`w-full  font-open-sans-semi-bold py-4 px-2 text-center`}
                  >
                    No rules found!
                  </p>
                )}
                {!addNewRuleMobile &&
                  rules.map(each => (
                    <div className="w-full shadow-inner shadow-md bg-white rounded px-2 py-2 ">
                      <p className="font-open-sans-bold capitalize">
                        {each?.breKycname}
                        <span
                          className="float-right ml-auto cursor-pointer"
                          onClick={() => {
                            setShowDrawer(true);
                            setMobileMoreData(each);
                          }}
                        >
                          <MoreHorizIcon />
                        </span>
                      </p>
                      <p className="text-xs text-grey-2240 font-open-sans ">
                        {moment(each?.createdAt).format('DD MMM YY')}
                      </p>
                      <hr className="text-blue-1100 mt-2 mb-1" />
                      <p className="font-open-sans-bold text-blue-1301 text-left mt-2">{`${each
                        ?.createdBy?.firstName || ''} ${each?.createdBy
                        ?.middleName || ''} ${each?.createdBy?.lastName ||
                        ''}`}</p>
                    </div>
                  ))}
              </div>
            </InfiniteScroll>
          </div>
        </div>

        <Modal
          show={showDeletePopUp}
          setShow={setShowDeletePopUp}
          title={
            <span className="font-bold font-open-sans-bold text-xl text-black-1011">
              Delete Rule!
            </span>
          }
        >
          <hr
            className="text-grey-1009 w-full mb-6 -mt-1"
            style={{ borderWidth: '1px' }}
          />
          <div className="w-full text-sm text-black-500 font-open-sans">
            <p className="font-open-sans text-xs">
              You are about to delete the rule associated with the BRE!
            </p>
            <p className="font-open-sans mt-4">
              <strong className="">Are you sure you want to proceed ?</strong>
            </p>
          </div>

          <div className="ml-auto flex flex-row-reverse mt-3 gap-4 font-open-sans">
            <button
              className="bg-white border  border-black-500 px-3 py-2 rounded "
              onClick={() => setShowDeletePopUp(false)}
            >
              Cancel
            </button>

            <button
              className="bg-red-200 text-white px-3 py-2 rounded "
              onClick={deleteBRECondition}
            >
              Delete
            </button>
          </div>
        </Modal>

        <PopUp
          type={popUpData?.type}
          text={popUpData?.text}
          show={popUpData?.show}
          setShow={() =>
            setPopUpData(e => {
              return { ...e, show: false };
            })
          }
          dontClose={true}
        />
      </div>
    </div>
  );
};

export default withErrorHandler(BREKYC);
